import React from "react";

import "../../../styles/css/App.css";

import { Switch, Route, useRouteMatch, withRouter } from "react-router-dom";
import TableUsers from "./table-users";
import UserForm from "./user-form";

function Users({ history }) {
  
  let { path, url } = useRouteMatch();

  const onOpen = (event, rowData) => {
    if (rowData !== undefined) {
      history.push(`${url}/` + rowData.id);
    }
  }

  const onClose = () => {
    history.goBack()
  }

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <TableUsers
            open={onOpen}/>
        </Route>
        <Route exact path={`${path}/:userId`}
          render={ (props) => 
            <UserForm 
              userId={props.match.params.userId}
              onCancel={onClose}/>
          }
        />
      </Switch>
    </div>
  );

}

export default withRouter(Users);
